import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Header from "../Header";
import Sidebar from "../Sidebar";
import "../../styles/theme.css";
import "../../styles/dashboard.css";
import "../../styles/ProfilesManager.css";
import { useSidebar } from "../../App";

export default function HelpCenter() {
  const { sidebarCollapsed } = useSidebar();
  const [activeMenu, setActiveMenu] = useState(null); // Controls which dropdown is open
  const [activeTab, setActiveTab] = useState("startMenu"); // Controls which content is visible
  const { t } = useTranslation("help");

  const toggleSubmenu = (menuId) => {
    setActiveMenu(activeMenu === menuId ? null : menuId);
  };

  return (
    <div className="theme-whbl">
      <style>
        {`
          .help-container {
            display: flex;
            min-height: 80vh;
            background: #000;
            border: 1px solid #333;
            border-radius: 8px;
            overflow: hidden;
            margin-top: 20px;
          }

          .help-sidebar {
            width: 300px;
            background: #182148;
            border-right: 1px solid #333;
            color: #fff;
          }

          .help-sidebar-header {
            padding: 20px;
            text-align: center;
            border-bottom: 1px solid #2d3a75;
          }

          .menu-btn {
            padding: 14px;
            cursor: pointer;
            border-bottom: 1px solid #2d3a75;
            font-size: 0.8rem;
            display: flex;
            justify-content: space-between;
            transition: background 0.2s;
          }

          .menu-btn:hover, .menu-btn.active {
            background: #010729;
            font-weight: bold;
          }

          .help-submenu {
            background: #1d3186;
          }

          .sub-tab {
            padding: 10px 10px 10px 25px;
            font-size: 0.7rem;
            cursor: pointer;
            border-bottom: 1px solid #2d3a75;
            color: #cbd5e1;
          }

          .sub-tab:hover { background: #674fee; color: #fff; }
          .sub-tab.active { background: #826df5; color: #fff; }

          .help-main-content {
            flex: 1;
            padding: 30px;
            background: #000;
            color: #fff;
            overflow-y: auto;
          }

          .help-main-content h3 {
            font-size: 1rem;
            margin-bottom: 20px;
            color: #fff;
            border-left: 4px solid #826df5;
            padding-left: 15px;
          }

          .help-main-content p {
            font-size: 0.8rem;
            line-height: 1.6;
            color: #cbd5e1;
          }

          .help-img {
            max-width: 100%;
            width: 600px;
            height: auto;
            border-radius: 4px;
            margin: 15px 0;
            border: 1px solid #333;
          }

          @media (max-width: 992px) {
            .help-container { flex-direction: column; }
            .help-sidebar { width: 100%; }
          }
        `}
      </style>

      <Header />

      <div className="container-fluid">
        <div className="main-container">
          <div className={`${sidebarCollapsed ? "col-1" : "col-2"} p-0`}>
            <Sidebar />
          </div>

          <main className={`${sidebarCollapsed ? "col-11" : "col-10"}`} style={{ width: "100%" }}>
            <div className="dashboard">
              <div style={{ marginBottom: "1rem" }}>
                <Link to="/dashboard" className="btn btn-secondary">
                  {t("helpCenter.content.backToDashboard", "← Back to Dashboard")}
                </Link>
              </div>

              <div className="help-container">
                {/* --- LEFT SIDEBAR --- */}
                <aside className="help-sidebar">
                  <div className="help-sidebar-header">
                    <h2 style={{ fontSize: '1rem', margin: 0 }}>
                      {t("helpCenter.sidebar.title", "Help Center")}
                    </h2>
                    <p style={{ fontSize: '0.7rem', color: '#94a3b8' }}>
                      {t("helpCenter.sidebar.subtitle", "Select a topic to learn more")}
                    </p>
                  </div>

                  {/* 1. How to Start */}
                  <div className={`menu-btn ${activeMenu === 'start' ? 'active' : ''}`} onClick={() => toggleSubmenu('start')}>
                    {t("helpCenter.sidebar.categories.start", "How to Start")} <span>{activeMenu === 'start' ? '▾' : '▸'}</span>
                  </div>
                  {activeMenu === 'start' && (
                    <div className="help-submenu">
                      <div className={`sub-tab ${activeTab === 'startMenu' ? 'active' : ''}`} onClick={() => setActiveTab('startMenu')}>
                        {t("helpCenter.sidebar.subTabs.startMenu", "How to Start?")}
                      </div>
                    </div>
                  )}

                  {/* 2. Login */}
                  <div className={`menu-btn ${activeMenu === 'login' ? 'active' : ''}`} onClick={() => toggleSubmenu('login')}>
                    {t("helpCenter.sidebar.categories.login", "Login & Sign up")} <span>{activeMenu === 'login' ? '▾' : '▸'}</span>
                  </div>
                  {activeMenu === 'login' && (
                    <div className="help-submenu">
                      <div className={`sub-tab ${activeTab === 'loginMenu' ? 'active' : ''}`} onClick={() => setActiveTab('loginMenu')}>
                        {t("helpCenter.sidebar.subTabs.loginMenu", "To access console")}
                      </div>
                    </div>
                  )}

                  {/* 3. AI Endpoints */}
                  <div className={`menu-btn ${activeMenu === 'endpoint' ? 'active' : ''}`} onClick={() => toggleSubmenu('endpoint')}>
                    {t("helpCenter.sidebar.categories.endpoint", "Create a New AI Endpoint")} <span>{activeMenu === 'endpoint' ? '▾' : '▸'}</span>
                  </div>
                  {activeMenu === 'endpoint' && (
                    <div className="help-submenu">
                      <div className={`sub-tab ${activeTab === 'endpointmenuf' ? 'active' : ''}`} onClick={() => setActiveTab('endpointmenuf')}>
                        {t("helpCenter.sidebar.subTabs.endpointmenuf", "First Method")}
                      </div>
                      <div className={`sub-tab ${activeTab === 'endpointmenus' ? 'active' : ''}`} onClick={() => setActiveTab('endpointmenus')}>
                        {t("helpCenter.sidebar.subTabs.endpointmenus", "Second Method")}
                      </div>
                      <div className={`sub-tab ${activeTab === 'endpointmenus1' ? 'active' : ''}`} onClick={() => setActiveTab('endpointmenus1')}>
                        {t("helpCenter.sidebar.subTabs.endpointmenus1", "Using Script")}
                      </div>
                    </div>
                  )}

                  {/* 4. Create Profile */}
                  <div className={`menu-btn ${activeMenu === 'profiles' ? 'active' : ''}`} onClick={() => toggleSubmenu('profiles')}>
                    {t("helpCenter.sidebar.categories.profiles", "Create Profile(DoS)")} <span>{activeMenu === 'profiles' ? '▾' : '▸'}</span>
                  </div>
                  {activeMenu === 'profiles' && (
                    <div className="help-submenu">
                      <div className={`sub-tab ${activeTab === 'profilemenu' ? 'active' : ''}`} onClick={() => setActiveTab('profilemenu')}>
                        {t("helpCenter.sidebar.subTabs.profilemenu", "Create Profile")}
                      </div>
                      <div className={`sub-tab ${activeTab === 'profilemenu2' ? 'active' : ''}`} onClick={() => setActiveTab('profilemenu2')}>
                        {t("helpCenter.sidebar.subTabs.profilemenu2", "Create Profile: Choose Profile Name and select Endpoint")}
                      </div>
                      <div className={`sub-tab ${activeTab === 'dosmenu' ? 'active' : ''}`} onClick={() => setActiveTab('dosmenu')}>
                        {t("helpCenter.sidebar.subTabs.dosmenu", "DoS Tester")}
                      </div>
                    </div>
                  )}

                  {/* 5. Prompt & Docs */}
                  <div className={`menu-btn ${activeMenu === 'pdocs' ? 'active' : ''}`} onClick={() => toggleSubmenu('pdocs')}>
                    {t("helpCenter.sidebar.categories.pdocs", "Prompt & Document Upload")} <span>{activeMenu === 'pdocs' ? '▾' : '▸'}</span>
                  </div>
                  {activeMenu === 'pdocs' && (
                    <div className="help-submenu">
                      <div className={`sub-tab ${activeTab === 'promptmenu' ? 'active' : ''}`} onClick={() => setActiveTab('promptmenu')}>
                        {t("helpCenter.sidebar.subTabs.promptmenu", "Document Upload")}
                      </div>
                      <div className={`sub-tab ${activeTab === 'llmmenu' ? 'active' : ''}`} onClick={() => setActiveTab('llmmenu')}>
                        {t("helpCenter.sidebar.subTabs.llmmenu", "LLM Test")}
                      </div>
                      <div className={`sub-tab ${activeTab === 'advancemenu' ? 'active' : ''}`} onClick={() => setActiveTab('advancemenu')}>
                        {t("helpCenter.sidebar.subTabs.advancemenu", "Advance Multi Stage/Multi Step Attacks")}
                      </div>
                      <div className={`sub-tab ${activeTab === 'pupload' ? 'active' : ''}`} onClick={() => setActiveTab('pupload')}>
                        {t("helpCenter.sidebar.subTabs.pupload", "Prompt Upload")}
                      </div>
                    </div>
                  )}

                  {/* 6. MCP Tester */}
                  <div className={`menu-btn ${activeMenu === 'mcp' ? 'active' : ''}`} onClick={() => toggleSubmenu('mcp')}>
                    {t("helpCenter.sidebar.categories.mcp", "MCP Tester")} <span>{activeMenu === 'mcp' ? '▾' : '▸'}</span>
                  </div>
                  {activeMenu === 'mcp' && (
                    <div className="help-submenu">
                      <div className={`sub-tab ${activeTab === 'mcpmenu' ? 'active' : ''}`} onClick={() => setActiveTab('mcpmenu')}>
                        {t("helpCenter.sidebar.subTabs.mcpmenu", "MCP Custom File")}
                      </div>
                      <div className={`sub-tab ${activeTab === 'esmcp' ? 'active' : ''}`} onClick={() => setActiveTab('esmcp')}>
                        {t("helpCenter.sidebar.subTabs.esmcp", "Example Script MCP DoS")}
                      </div>
                      <div className={`sub-tab ${activeTab === 'esmcp2' ? 'active' : ''}`} onClick={() => setActiveTab('esmcp2')}>
                        {t("helpCenter.sidebar.subTabs.esmcp2", "Example Script MCP")}
                      </div>
                      <div className={`sub-tab ${activeTab === 'esmcdi' ? 'active' : ''}`} onClick={() => setActiveTab('esmcdi')}>
                        {t("helpCenter.sidebar.subTabs.esmcdi", "Example Script MDI")}
                      </div>
                      <div className={`sub-tab ${activeTab === 'mcpmenu5' ? 'active' : ''}`} onClick={() => setActiveTab('mcpmenu5')}>
                        {t("helpCenter.sidebar.subTabs.mcpmenu5", "MCP Testing")}
                      </div>
                    </div>
                  )}

                  {/* 6.1. RTO */}
                  <div className={`menu-btn ${activeMenu === 'rto' ? 'active' : ''}`} onClick={() => toggleSubmenu('rto')}>
                    {t("helpCenter.sidebar.categories.rto", "RTO (Response Time Optimization)")} <span>{activeMenu === 'rto' ? '▾' : '▸'}</span>
                  </div>
                  {activeMenu === 'rto' && (
                    <div className="help-submenu">
                      <div className={`sub-tab ${activeTab === 'rto1' ? 'active' : ''}`} onClick={() => setActiveTab('rto1')}>
                        {t("helpCenter.sidebar.subTabs.rto1", "RTO (Response Time Optimization)")}
                      </div>
                      <div className={`sub-tab ${activeTab === 'lspf' ? 'active' : ''}`} onClick={() => setActiveTab('lspf')}>
                        {t("helpCenter.sidebar.subTabs.lspf", "Large Size Prompt File")}
                      </div>
                    </div>
                  )}

                  {/* 7. Running Scan */}
                  <div className={`menu-btn ${activeMenu === 'scan' ? 'active' : ''}`} onClick={() => toggleSubmenu('scan')}>
                    {t("helpCenter.sidebar.categories.scan", "Running the Scan")} <span>{activeMenu === 'scan' ? '▾' : '▸'}</span>
                  </div>
                  {activeMenu === 'scan' && (
                    <div className="help-submenu">
                      <div className={`sub-tab ${activeTab === 'runningmenu' ? 'active' : ''}`} onClick={() => setActiveTab('runningmenu')}>
                        {t("helpCenter.sidebar.subTabs.runningmenu", "Running the Scan")}
                      </div>
                    </div>
                  )}

                  {/* 8. End User */}
                  <div className={`menu-btn ${activeMenu === 'enduser' ? 'active' : ''}`} onClick={() => toggleSubmenu('enduser')}>
                    {t("helpCenter.sidebar.categories.enduser", "CSV File Format")} <span>{activeMenu === 'enduser' ? '▾' : '▸'}</span>
                  </div>
                  {activeMenu === 'enduser' && (
                    <div className="help-submenu">
                      <div className={`sub-tab ${activeTab === 'endusermenu' ? 'active' : ''}`} onClick={() => setActiveTab('endusermenu')}>
                        {t("helpCenter.sidebar.subTabs.endusermenu", "CSV Custom file/Upload CSV File")}
                      </div>
                    </div>
                  )}
                </aside>

                {/* --- RIGHT CONTENT AREA --- */}
                <section className="help-main-content">
                  {activeTab === 'startMenu' && (
                    <div>
                      <h3>{t("helpCenter.content.startMenu.title", "How to Start")}</h3>
                      <img src="/images/how-01.png" className="help-img" alt="Start" />
                    </div>
                  )}

                  {activeTab === 'loginMenu' && (
                    <div className="text-center">
                      <h3>{t("helpCenter.content.loginMenu.title", "Register & Sign up")}</h3>
                      <p>{t("helpCenter.content.loginMenu.description", "To access console open demo.whitehax.com")}</p>
                      <img src="/images/login-01.png" style={{ width: '300px' }} className="help-img" alt="Login 1" />
                      <img src="/images/login-02.png" style={{ width: '300px' }} className="help-img" alt="Login 2" />
                    </div>
                  )}

                  {activeTab === 'endpointmenuf' && (
                    <div>
                      <h3>{t("helpCenter.content.endpointmenuf.title", "New AI Endpoint (First Method)")}</h3>
                      <p>{t("helpCenter.content.endpointmenuf.description", '1: Choose "Configuration" > "AI Endpoints" from sidebar panel, Click on "New AI Endpoint", Fill information click next')}</p>
                      <img src="/images/Endpoint-01.png" className="help-img" alt="Endpoint" />
                    </div>
                  )}

                  {activeTab === 'endpointmenus' && (
                    <div>
                      <h3>{t("helpCenter.content.endpointmenus.title", "New Al Endpoint (Second Method)")}</h3>
                      <p>{t("helpCenter.content.endpointmenus.description", 'Choose Endpoint Name, enter URL in input box and click on JSONs tab, Fill JSONs in Request and Response input box and click on "Save" button')}</p>
                      <img src="/images/Endpoint-02.png" className="help-img" alt="Endpoint" />
                    </div>
                  )}

                  {activeTab === 'endpointmenus1' && (
                    <div>
                      <h3>{t("helpCenter.content.endpointmenus1.title", "Perform actions using Script")}</h3>
                      <p><strong>{t("helpCenter.content.endpointmenus1.initVenv", "Initialize venv")}</strong></p>
                      <pre style={{ background: '#111', padding: '10px', color: '#fff' }}>
                        $ cd py{"\n"}
                        $ source setup.sh
                      </pre>
                      <ul>
                        {(
                          t("helpCenter.content.endpointmenus1.instructions1", {
                            returnObjects: true,
                            defaultValue: [
                              "Set API Key in helper.py",
                              "cd to directory",
                              "Set parameterss in the file as needed",
                              "Run file"
                            ]
                          }) || []
                        ).map((item, idx) => (
                          <li key={idx}>{item}</li>
                        ))}
                      </ul>

                      <ul>
                        python3<br />
                        {t("helpCenter.content.endpointmenus1.flowTitle", "Flow:")}
                        {(
                          t("helpCenter.content.endpointmenus1.instructions2", {
                            returnObjects: true,
                            defaultValue: [
                              "Make endpoint",
                              "Fetch test files",
                              "Use endpoint id, test files info and profile config to create profile",
                              "Use profile id to run test"
                            ]
                          }) || []
                        ).map((item, idx) => (
                          <li key={idx}>{item}</li>
                        ))}
                      </ul>

                      <ul>
                        {t("helpCenter.content.endpointmenus1.notesTitle", "Notes")}
                        {(
                          t("helpCenter.content.endpointmenus1.instructions3", {
                            returnObjects: true,
                            defaultValue: [
                              "General: Change values at top of each file",
                              "Create Endpoint with i/o scripts:",
                              "Change values in input_script.py/output_script.py",
                              "Profile config params can be set in profile_config.json"
                            ]
                          }) || []
                        ).map((item, idx) => (
                          <li key={idx}>{item}</li>
                        ))}
                      </ul>

                      <p>{t("helpCenter.content.endpointmenus1.downloadNote", "Download folder and follow instructions")}</p>
                    </div>
                  )}

                  {activeTab === 'profilemenu' && (
                    <div>
                      <h3>{t("helpCenter.content.profilemenu.title", "Create Profile")}</h3>
                      <p>{t("helpCenter.content.profilemenu.step1", '1: Choose "Attack Surface Tests Status" from sidebar panel. Click "Create Profile"')}</p>
                      <img src="/images/c_profile-01.png" style={{ width: '400px' }} className="help-img" alt="Profile 1" />
                      <p>{t("helpCenter.content.profilemenu.step2", '2.Cllck on "Next" button. choose profile type')}</p><br />
                      <img src="/images/c_profile-02.png" style={{ width: '400px' }} className="help-img" alt="Profile 2" />
                    </div>
                  )}

                  {activeTab === 'profilemenu2' && (
                    <div>
                      <h3>{t("helpCenter.content.profilemenu2.title", "Create Profile")}</h3>
                      <p>{t("helpCenter.content.profilemenu2.step1", "Choose Profile Name and select Endpoint")}</p>
                      <img src="/images/c_profile-04.png" style={{ width: '400px' }} className="help-img" alt="Profile 4" />
                      <p>{t("helpCenter.content.profilemenu2.step2", 'Select Add/remove test files individual/multiple related to profile type through "Add test files" button, click on left/right arrow to select/deselect files.')}</p><br />
                      <img src="/images/c_profile-05.png" style={{ width: '400px' }} className="help-img" alt="Profile 5" /><br />
                      <p>{t("helpCenter.content.profilemenu2.exampleScript", "Example Script")}</p><br />
                      <img src="/images/c_profile-06.png" style={{ width: '400px' }} className="help-img" alt="Profile 6" />
                      <p>{t("helpCenter.content.profilemenu2.step1", "Choose Profile Name and select Endpoint")}</p>
                      <p>{t("helpCenter.content.profilemenu2.exampleScript", "Example Script")}</p><br />
                      <img src="/images/c_profile-07.png" style={{ width: '400px' }} className="help-img" alt="Profile 7" />
                    </div>
                  )}

                  {activeTab === 'dosmenu' && (
                    <div>
                      <h3>{t("helpCenter.content.dosmenu.title", "DoS Tester")}</h3>
                      <p>{t("helpCenter.content.dosmenu.description", 'Select all parameters from Agentic AI DoS. eg. Resource Exhaustion, Cost Amplification, Service Disruption,...etc, and change values accordingly. Click next to make profile. choose endpoint from dropdown, add custom DoS file through "Add test files" button, click on left/right arrow to select/deselect files.')}</p>
                      <img src="/images/dos-01.png" className="help-img" alt="DoS 1" /><br />
                      <img src="/images/dos-02.png" className="help-img" alt="DoS 2" /><br />
                      <img src="/images/dos-03.png" className="help-img" alt="DoS 3" /><br />
                      <img src="/images/dos-04.png" className="help-img" alt="DoS 4" /><br />
                      <img src="/images/dos-05.png" className="help-img" alt="DoS 5" /><br />
                      <img src="/images/dos-06.png" className="help-img" alt="DoS 6" /><br />
                    </div>
                  )}

                  {activeTab === 'promptmenu' && (
                    <div>
                      <h3>{t("helpCenter.content.promptmenu.title", "Prompt & Document Upload")}</h3>
                      <p>{t("helpCenter.content.promptmenu.description", "Select malicious document format from options given below . Choose endpoint from dropdown, Select Add/remove test files individual/multiple related to profile type through “Add test files” button, click on left/right arrow to select/deselect files.")}</p>
                      <img src="/images/promp-01.png" className="help-img" alt="Prompt 1" /><br />
                    </div>
                  )}

                  {activeTab === 'llmmenu' && (
                    <div>
                      <h3>{t("helpCenter.content.llmmenu.title", "LLM test")}</h3>
                      <p>{t("helpCenter.content.llmmenu.description", "Select all parameters from LLM API Mis-use/Abuse")}</p>
                      <img src="/images/promp-02.png" className="help-img" alt="Prompt 2" /><br />
                      <img src="/images/promp-03.png" className="help-img" alt="Prompt 3" /><br />
                    </div>
                  )}

                  {activeTab === 'advancemenu' && (
                    <div>
                      <h3>{t("helpCenter.content.advancemenu.title", "Advance Multi Stage/Multi Step Attacks")}</h3>
                      <p>{t("helpCenter.content.advancemenu.description", 'Choose "Prompt & Docs" and choose endpoint from dropdown, Select from "Advance Multi stage/Multi StepAttacks", click next')}</p>
                      <img src="/images/advance-01.png" className="help-img" alt="Advance 1" /><br />
                    </div>
                  )}

                  {activeTab === 'pupload' && (
                    <div>
                      <h3>{t("helpCenter.content.pupload.title", "Prompt Upload")}</h3>
                      <p>{t("helpCenter.content.pupload.description", '1. Choose "Prompt & Docs" and choose endpoint from dropdown, Select Add/remove test files individual/multiple related to profile type through "Add test files" button, click on left/right arrow to select/deselect files.')}</p>
                      <img src="/images/promp-upload-01.png" className="help-img" alt="Prompt Upload 1" /><br />
                    </div>
                  )}

                  {activeTab === 'mcpmenu' && (
                    <div>
                      <h3>{t("helpCenter.content.mcpmenu.title", "MCP Custom File")}</h3>
                      <p>{t("helpCenter.content.mcpmenu.description", "User can select all parameters from MCP Server Tests. eg. Resource Exhaustion, Protocol Violation, Tool Abuse....etc. and change values accordingly, Click next to make profile. Select Add/remove test files individual/multiple related to profile type through “Add test files” button, click on left/right arrow to select/deselect files.")}</p>
                      <img src="/images/mcp-01.png" className="help-img" alt="MCP 1" /><br />
                    </div>
                  )}

                  {activeTab === 'esmcp' && (
                    <div>
                      <h3>{t("helpCenter.content.esmcp.title", "Example Script MCP DoS")}</h3>
                      <img src="/images/mcp-02.png" className="help-img" alt="MCP 2" /><br />
                    </div>
                  )}

                  {activeTab === 'esmcp2' && (
                    <div>
                      <h3>{t("helpCenter.content.esmcp2.title", "Example Script MCP")}</h3>
                      <img src="/images/mcp-03.png" className="help-img" alt="MCP 3" /><br />
                    </div>
                  )}

                  {activeTab === 'esmcdi' && (
                    <div>
                      <h3>{t("helpCenter.content.esmcdi.title", "Example Script MDI")}</h3>
                      <img src="/images/mcp-04.png" className="help-img" alt="MCP 4" /><br />
                    </div>
                  )}

                  {activeTab === 'mcpmenu5' && (
                    <div>
                      <h3>{t("helpCenter.content.mcpmenu5.title", "MCP Testing")}</h3>
                      <img src="/images/mcp-05.png" className="help-img" alt="MCP 5" /><br />
                    </div>
                  )}

                  {activeTab === 'rto1' && (
                    <div>
                      <h3>{t("helpCenter.content.rto1.title", "RTO (Response Time Optimization)")}</h3>
                      <p>{t("helpCenter.content.rto1.description", "Response Time Optimization (RTO) in WhiteHaX AI-ASM test evaluates how efficiently your Agentic-AI processes requests under different input sizes and workloads.")}</p>
                      <img src="/images/rto-01.png" className="help-img" alt="RTO 1" /><br />
                      <img src="/images/rto-02.png" className="help-img" alt="RTO 2" /><br />
                    </div>
                  )}

                  {activeTab === 'lspf' && (
                    <div>
                      <h3>{t("helpCenter.content.lspf.title", "Large Size Prompt File")}</h3>
                      <p>{t("helpCenter.content.lspf.description", "Response Time Optimization (RTO) in WhiteHaX AI-ASM test evaluates how efficiently your Agentic-AI processes requests under different input sizes and workloads.")}</p>
                      <img src="/images/rto-02.png" className="help-img" alt="RTO 2" /><br />
                    </div>
                  )}

                  {activeTab === 'runningmenu' && (
                    <div>
                      <h3>{t("helpCenter.content.runningmenu.title", "Running the Scan")}</h3>
                      <p>{t("helpCenter.content.runningmenu.step1", "1. Please enter your credentials")}</p>
                      <img src="/images/scan-01.png" className="help-img" alt="Scan 1" />
                      <p>{t("helpCenter.content.runningmenu.step2", "2. After login successfully user run the test from Landing page or")}</p>
                      <img src="/images/scan-02.png" className="help-img" alt="Scan 2" /><br />
                      <p>{t("helpCenter.content.runningmenu.step3", "3. If user want to schedule Test, user able to schedule test")}</p>
                      <img src="/images/scan-03.png" className="help-img" alt="Scan 3" /><br />
                      <p>{t("helpCenter.content.runningmenu.runningNote", "Once test start running below screen will appear")}</p>
                      <img src="/images/scan-04.png" className="help-img" alt="Scan 4" /><br />
                      <p>{t("helpCenter.content.runningmenu.progressNote", "User can see progress of test")}</p>
                      <img src="/images/scan-05.png" className="help-img" alt="Scan 5" /><br />

                      <p>{t("helpCenter.content.runningmenu.step4", "4. Once verification is completed, Report page will show the report")}</p>
                      <img src="/images/scan-06.png" className="help-img" alt="Scan 6" /><br />

                      <p>{t("helpCenter.content.runningmenu.step5", "5. Click on Details tab to see detail report")}</p>
                      <img src="/images/scan-07.png" className="help-img" alt="Scan 7" /><br />
                    </div>
                  )}

                  {activeTab === 'endusermenu' && (
                    <div>
                      <h3>{t("helpCenter.content.endusermenu.title", "Upload CSV file")}</h3>
                      <img src="/images/csv-01.png" className="help-img" alt="CSV 1" /><br />
                      <p>{t("helpCenter.content.endusermenu.subtitle", "Running the Scan")}</p>
                      <img src="/images/csv-02.png" className="help-img" alt="CSV 2" /><br />
                      <img src="/images/csv-03.png" className="help-img" alt="CSV 3" /><br />
                    </div>
                  )}
                </section>
              </div>
            </div>
          </main>
        </div>
      </div>
    </div>
  );
}